module.exports = __webpack_public_path__ + "img/icon_jbxx.60670840.png";